<template>
    <el-card>
        <el-select
            v-show="mecSelect"
            v-model="value"
            placeholder="请选择"
            @change="currentSel"
        >
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.name"
                :value="item.id"
            >
            </el-option>
        </el-select>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="基础参数" name="first">
                <el-row type="flex" justify="left">
                    <el-form
                        style="width: 100%"
                        ref="form1"
                        :get-data="getData"
                        :form.sync="form"
                    >
                        <el-form-item label="品牌名称" class="el_child">
                            <el-input v-model="form.name"></el-input>
                        </el-form-item>
                        <!--                        <el-form-item-->
                        <!--                            label="分成比例"-->
                        <!--                            class="el_child"-->
                        <!--                        >-->
                        <!--                            <el-input v-model="form.proportion"></el-input>-->
                        <!--                        </el-form-item>-->
                        <el-form-item label="押金金额" class="el_child">
                            <el-input v-model="form.cash"></el-input>
                        </el-form-item>
                        <el-form-item label="自动退款" class="el_child">
                            <el-switch v-model="form.is_refund"></el-switch>
                        </el-form-item>
                        <el-form-item label="负责人名称" class="el_child">
                            <el-input v-model="form.username"></el-input>
                        </el-form-item>
                        <el-form-item label="负责人手机号" class="el_child">
                            <el-input v-model="form.phone"></el-input>
                        </el-form-item>
                        <el-form-item label="负责人邮箱" class="el_child">
                            <el-input v-model="form.email"></el-input>
                        </el-form-item>
                        <el-form-item label="所在区域" class="el_child">
                            <el-input v-model="form.area_name"></el-input>
                        </el-form-item>
                        <el-form-item label="退款回调地址" class="el_child">
                            <el-input
                                v-model="form.refund_callback_url"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="车辆二维码地址" class="el_child">
                            <el-input v-model="form.car_qr_code_url"></el-input>
                        </el-form-item>
                        <!--                        <el-form-item-->
                        <!--                            label="地勤二维码"-->
                        <!--                            required-->
                        <!--                            prop="ground_qr_code"-->
                        <!--                            class="el_child"-->
                        <!--                        >-->
                        <!--                            <el-upload-->
                        <!--                                class="avatar-uploader"-->
                        <!--                                action="/admin-api/admin_merchant_uplode"-->
                        <!--                                name="ground_qr_code"-->
                        <!--                                :headers="uploadHeaders"-->
                        <!--                                :show-file-list="false"-->
                        <!--                                :on-success="ground_qr_code_success"-->
                        <!--                                :before-upload="beforeAvatarUpload"-->
                        <!--                            >-->
                        <!--                                <img-->
                        <!--                                    v-if="form.ground_qr_code"-->
                        <!--                                    :src="form.ground_qr_code"-->
                        <!--                                    class="avatara"-->
                        <!--                                >-->
                        <!--                                <i-->
                        <!--                                    v-else-->
                        <!--                                    class="el-icon-plus avatar-uploader-icon"-->
                        <!--                                />-->
                        <!--                            </el-upload>-->
                        <!--                        </el-form-item>-->
                        <!--                        <el-form-item-->
                        <!--                            label="厂测试二维码"-->
                        <!--                            required-->
                        <!--                            prop="factory_qr_code"-->
                        <!--                            class="el_child"-->
                        <!--                        >-->
                        <!--                            <el-upload-->
                        <!--                                class="avatar-uploader"-->
                        <!--                                action="/admin-api/admin_merchant_uplode"-->
                        <!--                                name="factory_qr_code"-->
                        <!--                                :headers="uploadHeaders"-->
                        <!--                                :show-file-list="false"-->
                        <!--                                :on-success="factory_qr_code_success"-->
                        <!--                                :before-upload="beforeAvatarUpload"-->
                        <!--                            >-->
                        <!--                                <img-->
                        <!--                                    v-if="form.factory_qr_code"-->
                        <!--                                    :src="form.factory_qr_code"-->
                        <!--                                    class="avatara"-->
                        <!--                                >-->
                        <!--                                <i-->
                        <!--                                    v-else-->
                        <!--                                    class="el-icon-plus avatar-uploader-icon"-->
                        <!--                                />-->
                        <!--                            </el-upload>-->
                        <!--                        </el-form-item>-->

                        <el-form-item style="margin-left: 30%">
                            <el-button
                                type="primary"
                                size="small"
                                @click="onSubmit(1)"
                                >确认修改</el-button
                            >
                            <!--                            <el-button size="small">取消</el-button>-->
                        </el-form-item>
                    </el-form>
                </el-row>
            </el-tab-pane>
            <el-tab-pane label="开发参数" name="exploit">
                <el-row type="flex" justify="left">
                    <el-form
                        ref="form2"
                        :get-data="getData"
                        :form.sync="form"
                        style="width: 50%"
                    >
                        <!--<el-alert
                            title="小程序参数配置"
                            type="success"
                        ></el-alert>-->
                        <el-form-item label="小程序名称" label-width="25%">
                            <el-input v-model="form.wxapp_name"></el-input>
                        </el-form-item>
                        <el-form-item label="平台名称" label-width="25%">
                            <el-input v-model="form.brand"></el-input>
                        </el-form-item>
                        <el-form-item label="描述" label-width="25%">
                            <el-input v-model="form.wxapp_desc"></el-input>
                        </el-form-item>
                        <el-form-item label="微信-appID" label-width="25%">
                            <el-input v-model="form.wxapp_app_id"></el-input>
                        </el-form-item>
                        <el-form-item
                            label="微信-小程序AppSecret(密钥)"
                            label-width="25%"
                            class="el-form-item__label1"
                        >
                            <el-input
                                v-model="form.wxapp_app_secret"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="默认支付"
                            required
                            label-width="25%"
                            class="el-form-item__label1"
                        >
                            <el-select
                                v-model="form.default_pay_merchant_id"
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="item in merchantList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="平台小程序二维码地址"
                            required
                            prop="wxapp_qr_code"
                            label-width="25%"
                        >
                            <el-upload
                                class="avatar-uploader"
                                action="/admin-api/admin_merchant_uplode"
                                name="wxapp_qr_code"
                                :headers="uploadHeaders"
                                :show-file-list="false"
                                :on-success="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload"
                            >
                                <img
                                    v-if="form.wxapp_qr_code"
                                    :src="form.wxapp_qr_code"
                                    class="avatara"
                                />
                                <i
                                    v-else
                                    class="el-icon-plus avatar-uploader-icon"
                                />
                            </el-upload>
                        </el-form-item>
                        <el-form-item style="margin-left: 6%">
                            <el-button
                                type="primary"
                                size="small"
                                @click="onSubmit(2)"
                                >确认修改</el-button
                            >
                            <!--                            <el-button size="small">取消</el-button>-->
                        </el-form-item>
                    </el-form>
                </el-row>
            </el-tab-pane>
            <el-tab-pane label="微信-支付参数" name="pay">
                <el-row type="flex" justify="left">
                    <el-form
                        style="width: 40%"
                        ref="form3"
                        :get-data="getData"
                        :form.sync="form"
                    >
                        <!-- <el-alert title="微信商户平台" type="success"></el-alert>-->

                        <el-form-item label="商户号">
                            <el-input v-model="form.pay_mch_id"></el-input>
                        </el-form-item>
                        <el-form-item label="API密钥">
                            <el-input v-model="form.pay_key"></el-input>
                        </el-form-item>
                        <el-form-item
                            label="PayCertPath"
                            required
                            prop="pay_cert_path"
                        >
                            <el-upload
                                class="avatar-uploader"
                                action="/admin-api/admin_merchant_uplode_pay?type=pay_cert"
                                name="file"
                                :headers="uploadHeaders"
                                :data="uploadData"
                                accept="pem"
                                :show-file-list="false"
                                :on-success="handlePayCertPathSuccess"
                                :before-upload="beforePayUpload"
                            >
                                <el-button
                                    type="primary"
                                    v-if="form.pay_cert_path"
                                    >已上传</el-button
                                >
                                <el-button type="danger" v-else
                                    >上传文件</el-button
                                >
                            </el-upload>
                        </el-form-item>
                        <el-form-item
                            label="PayKeyPath"
                            required
                            prop="pay_key_path"
                        >
                            <el-upload
                                class="avatar-uploader"
                                action="/admin-api/admin_merchant_uplode_pay?type=pay_key_path"
                                name="file"
                                :data="uploadData"
                                :headers="uploadHeaders"
                                :show-file-list="false"
                                :on-success="handlePayKeyPathSuccess"
                                :before-upload="beforePayUpload"
                            >
                                <el-button
                                    type="primary"
                                    v-if="form.pay_key_path"
                                    >已上传</el-button
                                >
                                <el-button type="danger" v-else
                                    >上传文件</el-button
                                >
                            </el-upload>
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                type="primary"
                                size="small"
                                @click="onSubmit(3)"
                                >确认修改</el-button
                            >
                            <!--                            <el-button size="small">取消</el-button>-->
                        </el-form-item>
                    </el-form>
                </el-row>
            </el-tab-pane>

            <el-tab-pane label="支付宝-支付参数" name="alipaymini">
                <el-row type="flex" justify="left">
                    <el-form
                        style="width: 80%"
                        ref="form4"
                        :get-data="getData"
                        :form.sync="form"
                    >
                        <!--<el-alert title="支付宝商户平台" type="success"></el-alert>-->

                        <el-form-item label="支付宝小程序APPID">
                            <el-input
                                v-model="form.alipaymini_appId"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="支付宝应用公钥">
                            <el-input
                                type="textarea"
                                :rows="12"
                                v-model="form.alipaymini_merchantPrivateKey"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="支付宝接口内容加密解密AES"
                            label-width="300"
                        >
                            <el-input
                                v-model="form.alipaymini_aesKey"
                                style="width: 30%"
                            ></el-input>
                        </el-form-item>

                        <!--                        <el-form-item label="支付宝公钥证书">-->
                        <!--                            <el-input v-model="form.alipaymini_merchantCertPath"></el-input>-->
                        <!--                        </el-form-item>-->
                        <!--                        <el-form-item label="支付宝支付证书">-->
                        <!--                            <el-input v-model="form.alipaymini_alipayCertPath"></el-input>-->
                        <!--                        </el-form-item>-->
                        <!--                        <el-form-item label="支付宝支付根证书">-->
                        <!--                            <el-input v-model="form.alipaymini_alipayRootCertPath"></el-input>-->
                        <!--                        </el-form-item>-->

                        <el-form-item
                            label="支付宝支付证书alipayCertPublicKey_RSA2.crt"
                            required
                            prop="pay_cert_path"
                            label-width="300"
                        >
                            <!--                            支付宝支付证书-->
                            <el-upload
                                class="avatar-uploader"
                                action="/admin-api/admin_merchant_uplode_pay?type=alipayCertPublicKey_RSA2&pay_type=2"
                                name="file"
                                :headers="uploadHeaders"
                                :data="uploadData"
                                accept="pem"
                                :show-file-list="false"
                                :on-success="
                                    handlealipaymini_alipayCertPathSuccess
                                "
                                :before-upload="beforePayUpload"
                            >
                                <el-button
                                    type="primary"
                                    v-if="form.alipaymini_alipayCertPath"
                                    >已上传</el-button
                                >
                                <el-button type="danger" v-else
                                    >上传文件</el-button
                                >
                            </el-upload>
                        </el-form-item>
                        <el-form-item
                            label="支付宝根证书alipayRootCert.crt"
                            required
                            prop="pay_key_path"
                            label-width="300"
                        >
                            <!--                            支付宝根证书-->
                            <el-upload
                                class="avatar-uploader"
                                action="/admin-api/admin_merchant_uplode_pay?type=alipayRootCert&pay_type=2"
                                name="file"
                                :data="uploadData"
                                :headers="uploadHeaders"
                                :show-file-list="false"
                                :on-success="handlealipayRootCertPathSuccess"
                                :before-upload="beforePayUpload"
                            >
                                <el-button
                                    type="primary"
                                    v-if="form.alipaymini_alipayRootCertPath"
                                    >已上传</el-button
                                >
                                <el-button type="danger" v-else
                                    >上传文件</el-button
                                >
                            </el-upload>
                        </el-form-item>
                        <el-form-item
                            label="支付宝公钥证书appCertPublicKey_2021002113630150.crt"
                            required
                            prop="pay_key_path"
                            label-width="auto"
                        >
                            <!--                            支付宝公钥证书-->
                            <el-upload
                                class="avatar-uploader"
                                action="/admin-api/admin_merchant_uplode_pay?type=appCertPublicKey_2021002113630150&pay_type=2"
                                name="file"
                                :data="uploadData"
                                :headers="uploadHeaders"
                                :show-file-list="false"
                                :on-success="handlemerchantCertPathSuccess"
                                :before-upload="beforePayUpload"
                            >
                                <el-button
                                    type="primary"
                                    v-if="form.alipaymini_merchantCertPath"
                                    >已上传</el-button
                                >
                                <el-button type="danger" v-else
                                    >上传文件</el-button
                                >
                            </el-upload>
                        </el-form-item>
                        <el-form-item style="margin-left: 40%">
                            <el-button
                                type="primary"
                                size="small"
                                @click="onSubmit(4)"
                                >确认修改</el-button
                            >
                            <!--                            <el-button size="small">取消</el-button>-->
                        </el-form-item>
                    </el-form>
                </el-row>
            </el-tab-pane>
        </el-tabs>
    </el-card>
</template>
<script>
import {
    getMerchantConfig,
    editMerchantConfig,
    getMerchantList,
} from "@/api/admin-merchant";
import { getToken } from "@/libs/token";
export default {
    data() {
        return {
            activeName: "first",
            form: {
                default_pay_merchant_id: 0,
            },
            options: [],
            value: "",
            uploadHeaders: {
                Authorization: "",
            },
            uploadData: {
                id: 0,
            },
            mecSelect: true,
            merchantList: [], //商户id列表
        };
    },
    async created() {
        this.value = this.$route.query.id;

        this.uploadHeaders.Authorization = getToken();
        await this.getMerchant();
        await this.getData();
        console.log(this.$store.state.users.user.roles, "校色");
        if (this.$store.state.users.user.roles[0] === "merchantsAdmin") {
            this.mecSelect = false;
        }
    },

    methods: {
        async getMerchant() {
            const { data } = await getMerchantList();
            this.merchantList = [{ id: 0, name: "暂不设置" }].concat(data);
        },
        handleClick(tab, event) {
            console.log(tab, event);
        },
        currentSel(selVal) {
            console.log(selVal);
            this.value = selVal;
            this.getData();
        },
        async onSubmit(sub_type) {
            this.form.sub_type = sub_type;

            const res = await editMerchantConfig(this.form);

            if (res.data.status === 1) {
                this.$message({
                    message: "保存成功！",
                    type: "success",
                });
            } else {
                this.$message.error("保存失败稍候再试");
            }
        },
        async getData(params = {}) {
            if (this.value) {
                params = { id: this.value };
            }
            const { data } = await getMerchantConfig(params);
            this.form = data;
            console.log(data, "商户信息---------");
            console.log(this.value, "商户信息---------this.value");
            console.log(params, "商户信息---------params");

            this.options = data["mch_list"];

            this.value = data["id"];
            this.uploadData.id = this.value;
        },
        handleAvatarSuccess(res, file) {
            this.form.wxapp_qr_code = res.path;
        },
        factory_qr_code_success(res, file) {
            this.form.factory_qr_code = res.path;
        },
        ground_qr_code_success(res, file) {
            this.form.ground_qr_code = res.path;
        },
        handlePayCertPathSuccess(res, file) {
            this.form.pay_cert_path = res.path;
        },
        handlePayKeyPathSuccess(res, file) {
            this.form.pay_key_path = res.path;
        },
        handlealipaymini_alipayCertPathSuccess(res, file) {
            //支付宝支付证书
            this.form.alipaymini_alipayCertPath = res.path;
        },
        handlealipayRootCertPathSuccess(res, file) {
            //支付宝支付根证书
            this.form.alipaymini_alipayRootCertPath = res.path;
        },
        handlemerchantCertPathSuccess(res, file) {
            //支付宝公钥证书
            this.form.alipaymini_merchantCertPath = res.path;
        },
        beforePayUpload(file) {
            console.log(file);
            const isPem = file.type === "application/x-x509-ca-cert";
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isPem) {
                this.$message.error("上传文件只支持pem格式!");
            }
            if (!isLt2M) {
                this.$message.error("上传大小不能超过 2MB!");
            }
            return isPem && isLt2M;
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === "image/jpeg";
            const isPNG = file.type === "image/png";
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG && !isPNG) {
                this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
            }
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 2MB!");
            }
            return (isJPG || isPNG) && isLt2M;
        },
    },
};
</script>
<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    /* height: 178px; */
    display: block;
}
.el_child {
    display: inline-block;
    vertical-align: middle;
    width: 40%;
}
.lable-left {
    display: inline-block;
    vertical-align: middle;
    widows: 300 !important;
}
.el-form-item__label1 {
    text-align: left !important;
}
</style>
